import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../../shared.module';
import { RouterModule } from '@angular/router';
import { CalendarDatePickerComponent } from './calendar-date-picker.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    RouterModule
  ],
  declarations: [CalendarDatePickerComponent],
  exports: [CalendarDatePickerComponent]
})
export class CalendarDatePickerComponentModule {}
